import React from 'react';
import './FireNocs.css'; // Create a CSS file for Fire NOC specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_fire_noc_banner from '../../assets/images/fire-2.jpg'; // Replace with the actual image for fire NOC
import { FaFireExtinguisher, FaGavel, FaShieldAlt, FaCertificate, FaClipboardList, FaPaperPlane } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function FireNocs() {
  const fireNocBenefits = [
    {
      icon: <FaShieldAlt />,
      title: 'Enhanced Safety',
      text: 'Ensure your building complies with fire safety standards for the safety of occupants.',
    },
    {
      icon: <FaCertificate />,
      title: 'Legal Compliance',
      text: 'Obtain the required Fire NOC to avoid penalties and ensure legal compliance.',
    },
    {
      icon: <FaFireExtinguisher />,
      title: 'Risk Mitigation',
      text: 'Minimize fire-related risks with an official No Objection Certificate.',
    },
    {
      icon: <FaGavel />,
      title: 'Regulatory Approval',
      text: 'Ensure regulatory authorities approve your fire safety measures with the NOC.',
    },
  ];

  const steps = [
    {
      icon: <FaClipboardList />,
      title: 'Initial Consultation',
      description: 'Discuss the requirements for obtaining Fire NOC and necessary fire safety measures.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Documentation Preparation',
      description: 'Prepare and gather all required documents for Fire NOC application.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Safety Assessment',
      description: 'Assess your premises to ensure it meets the fire safety standards required for the NOC.',
    },
    {
      icon: <FaCertificate />,
      title: 'Application Submission',
      description: 'Submit the Fire NOC application and follow up with the authorities.',
    },
    {
      icon: <FaFireExtinguisher />,
      title: 'Fire NOC Issuance',
      description: 'Receive your Fire NOC and proceed with your operations while ensuring safety compliance.',
    },
  ];

  const acts = [
    'National Building Code (NBC)',
    'Fire Safety Act',
    'Local Fire Safety Regulations',
  ];

  const explanation =
    'These regulations ensure that buildings and establishments adhere to fire safety norms, preventing potential hazards and ensuring safety for all occupants.';

  const checklistItems = [
    { name: 'Building Plan Approval', description: 'Submit the approved building plans that comply with fire safety standards.' },
    { name: 'Fire Safety Equipment', description: 'Provide details of installed fire safety equipment and fire exits.' },
    { name: 'Fire Safety Audit', description: 'Include a recent fire safety audit report for the premises.' },
    { name: 'No Objection Certificate (NOC)', description: 'Attach a copy of the NOC from the local fire authority.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Fire NOC & Compliance"
        subheading="Ensure fire safety compliance with the issuance of the Fire No Objection Certificate (NOC)."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/fire-nocs' }}
        backgroundImage={img_fire_noc_banner} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is Fire NOC?"
        description="Fire NOC (No Objection Certificate) is a mandatory document issued by local fire authorities to ensure that a building or establishment complies with fire safety standards. Our services simplify the process of obtaining a Fire NOC."
        image={img_fire_noc_banner} // Image for the Fire NOC process
        altText="Fire NOC Process"
      />

      <ServicesBenefitsSection
        title="Why You Need Fire NOC"
        description="Understand the key benefits of obtaining a Fire NOC for your building or establishment."
        benefits={fireNocBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Fire Safety and Compliance Regulations"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple Fire NOC Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Fire NOC Onboarding Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
